import { useState } from "react";
import { useAsync } from "react-async";
import { DashboardProps, DashboardPropsDefaults } from "../../types/dashboardProps.d";
import { getCurrentTimesheetStatusesByTherapist } from '../../../../api/services/timesheetService';
import { hasValue, isTodayBeforeLastFridayOfMonth } from "../../../../common/utils";
import { useHistory } from "react-router-dom";
import { SelectedRange } from "../../../../pages/timesheets";
import Spinner from "../../../spinner";
import moment from "moment";
import TimesheetWidgetModel from "../../../../api/models/timesheetWidgetModel";

const fetchCurrentTimesheetStatusesByTherapist = async ({ id }: any) => await getCurrentTimesheetStatusesByTherapist(id);

const DashboardWidgetTherapistTimesheets = ({ user }: DashboardProps): JSX.Element => {
    const [timesheets, setTimesheets] = useState<TimesheetWidgetModel[]>([]);
    const history = useHistory();
    const id: number = user.userId!;

    const asyncTimesheets = useAsync({
        promiseFn: fetchCurrentTimesheetStatusesByTherapist, id,
        onResolve: (r) => setTimesheets(r.data)
    });

    /**
     * Accepts a timesheet and redirects user to it
     * @param ts: TimesheetSummary
     */
    const handleTimesheetClick = (ts: TimesheetWidgetModel) => {
        if (hasValue(ts?.timesheetWeekId) &&
            hasValue(ts.startDate) &&
            hasValue(ts.endDate))
            history.push(`/timesheets`,
                {
                    range: {
                        startDate: new Date(ts.startDate),
                        endDate: new Date(ts.endDate),
                    } as SelectedRange,
                    disciplineId: ts.disciplineId
                }
            );
    }

    return (
        <>
            <div className={DashboardPropsDefaults.containerClassNames}>
                <div className="pb-1 dashboard-widget-title">
                    <h3>Timesheets</h3>
                </div>
                <div className={DashboardPropsDefaults.contentClassNames}>
                    <Spinner show={asyncTimesheets.isPending} />
                    {!asyncTimesheets.isPending && (
                        <>
                            {timesheets && timesheets.length > 0 && (
                                <>
                                    {timesheets.map((ts: TimesheetWidgetModel) => (
                                        <div
                                            key={`ts-widget-${ts.timesheetId}-${Math.random()}`}
                                            className={`underline hover:no-underline mb-2 ${isTodayBeforeLastFridayOfMonth() ? 'text-ptsblue-500' : 'text-red-500'}`}
                                        >
                                            <span
                                                className={`underline hover:no-underline cursor-pointer`}
                                                onClick={(e) => handleTimesheetClick(ts)}
                                            >{`${ts.disciplineName} - ${moment(ts.startDate).format('MMM D')}-${moment(ts.endDate).format('D yyyy')}`} - {isTodayBeforeLastFridayOfMonth() ? (ts.timesheetStatusName ? ts.timesheetStatusName : 'N/A') : 'Overdue'}</span>
                                        </div>
                                    ))}
                                </>
                            )}
                        </>
                    )}
                </div>
            </div>
        </>
    );
};

export default DashboardWidgetTherapistTimesheets;
